var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "44px",
    viewBox: "0 0 90 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Set Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3100FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3100FF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Set-+-TokenSets"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20-Copy",
    transform: "translate(0.223589, 0.164535)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(16.566618, 15.200993) rotate(-90.000000) translate(-16.566618, -15.200993) translate(1.566618, 0.700993)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 14.8327083,
    cy: 14.255783,
    rx: 14.8327083,
    ry: 14.2274455
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(15.481025, 29.037061) rotate(-270.000000) translate(-15.481025, -29.037061) translate(0.481025, 14.537061)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 14.8327083,
    cy: 14.255783,
    rx: 14.8327083,
    ry: 14.2274455
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M51.0165589,35.3475309 C47.1101493,35.3475309 43.9361914,34.4406858 41.4249281,33.0106608 L43.6222835,26.3488372 L43.7966768,26.3488372 C45.0174298,31.2318493 48.8192035,33.7431126 52.3419479,33.7431126 C54.3300314,33.7431126 55.794935,32.5921169 55.794935,30.7435481 C55.794935,29.627431 55.3415124,28.5810713 53.3185503,27.6742262 L47.5286931,25.0234482 C44.1105847,23.41903 42.3317732,20.5589801 42.3317732,17.4896582 C42.3317732,13.6878845 44.7384005,9.53732429 51.714132,9.53732429 C54.8532112,9.53732429 58.4805916,10.5488054 60.5384324,11.6998011 L58.0271691,17.4199009 L57.8527758,17.4199009 C56.4576295,13.129826 53.353429,11.0719852 50.3189857,11.0719852 C47.7728437,11.0719852 46.8659986,12.3624956 46.8659986,13.5134913 C46.8659986,14.664487 47.4589358,15.7457253 49.3075047,16.6525704 L55.2717551,19.4777417 C59.1084074,21.2565532 60.2594031,23.4539087 60.2594031,26.4883519 C60.2594031,31.4411212 56.5622654,35.3475309 51.0165589,35.3475309 Z M71.9299127,29.9762176 C73.6738456,29.9762176 74.9643559,29.4530377 75.9060797,28.1276488 L76.1851089,28.1974061 C75.2433852,33.5687193 71.6160048,35.1731376 68.8257122,35.1731376 C64.8146666,35.1731376 60.8733783,31.9643011 60.8733783,25.860536 C60.8733783,20.0009216 64.3263654,15.8154827 69.0698628,15.8154827 C72.0345487,15.8154827 76.2548662,17.3850222 76.2548662,24.0119672 L66.2098129,24.0119672 C66.7329927,27.9532555 68.8257122,29.9762176 71.9299127,29.9762176 Z M68.3025323,16.9664784 C66.8725074,16.9664784 66.0702982,18.8150472 66.0702982,21.9541264 C66.0702982,22.302913 66.0702982,22.6168209 66.1051769,22.9307288 L70.4301304,22.9307288 C70.4301304,18.326746 69.6976786,16.9664784 68.3025323,16.9664784 Z M89.4251581,29.9064603 L89.739066,30.0110963 C88.9717355,32.5921169 86.8790161,35.1731376 83.2516357,35.1731376 C79.9381632,35.1731376 78.4732596,33.0455395 78.4732596,30.1506109 L78.4732596,17.3152649 L76.7642054,17.3152649 L76.7642054,17.1408716 C79.449862,14.8388802 82.3099119,12.7112821 85.0653259,10.3046548 L85.1002045,10.3046548 L85.1002045,16.4084198 L88.309041,16.4084198 L88.309041,17.2803863 L85.1002045,17.2803863 L85.1002045,29.2088871 C85.1002045,30.7086694 85.762899,31.6852718 86.983652,31.6852718 C88.3439197,31.6852718 89.1112502,30.7784267 89.4251581,29.9064603 Z",
    id: "Set-Protocol",
    fill: "#0F0835"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSet);
export default __webpack_public_path__ + "static/media/set.afbb998e7b9a336db0da28d0e4ad0729.svg";
export { ForwardRef as ReactComponent };